<div *ngIf="errors?.length > 0" class="alert alert-danger">
  <ul>
    <li *ngFor="let error of errors" style="font-size: 0.9rem">{{ error }}</li>
  </ul>
</div>
